import css from './CommentPreview.module.css';

interface Props {
  avatarUrl: string;
  nickname?: string;
  text?: string;
}

export function CommentPreview({ avatarUrl, nickname, text }: Props) {
  return (
    <div className={css.root}>
      <img className={css.avatar} src={avatarUrl} alt="" />
      <div className={css.body}>
        {nickname && <div className={css.nickname}>{nickname}</div>}
        {text && <div className={css.text}>{text}</div>}
      </div>
    </div>
  );
}
